import { Component, OnInit, inject } from "@angular/core";
import { AnalyticsService } from "@cariloop/analytics";
import { SupportedLanguage } from "@cariloop/ui-components";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { DevicePlatformService } from "app/shared/services/device-platform.service";
import { environment } from "environments/environment";

@Component({
  selector: "app-cta-mobile",
  templateUrl: "./cta-mobile.component.html",
  styleUrls: ["./cta-mobile.component.scss"],
  standalone: false,
})
export class CtaMobileComponent implements OnInit {
  readonly #analyticsService = inject(AnalyticsService);
  readonly #translate = inject(TranslateService);
  readonly #devicePlatformService = inject(DevicePlatformService);
  currentEnvironment = environment.envName === "production" ? "prod" : "dev";
  lang = SupportedLanguage.EN;

  ngOnInit(): void {
    this.lang = (this.#translate.getCurrentLang() ||
      this.#translate.getFallbackLang()) as SupportedLanguage;
    this.#translate.onLangChange.subscribe((lang: LangChangeEvent) => {
      this.lang = lang.lang as SupportedLanguage;
    });
  }

  downloadAppClicked(type: "apple" | "google") {
    const eventType =
      type === "apple"
        ? "apple_app_store_clicked"
        : "google_play_store_clicked";
    const deviceType = this.#devicePlatformService.getDeviceType();

    this.#analyticsService.trackEvent(eventType, {
      timestamp: new Date().toISOString(),
      source: "auth",
      deviceType,
    });
  }
}
